"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StateQueryStore = void 0;
var mobx_1 = require("mobx");
var mobx_utils_1 = require("mobx-utils");
var StateQueryStore = /** @class */ (function () {
    function StateQueryStore() {
        var _this = this;
        this.state = {};
        this.getKey = mobx_utils_1.createTransformer(function (key) {
            var value = _this.state[key];
            if (value) {
                return value.map(decodeURIComponent);
            }
            else {
                return undefined;
            }
        });
        new URLSearchParams(window.location.search)
            .forEach(function (v, k) {
            _this.state[k] = decodeURIComponent(v).split('|');
        });
        mobx_1.autorun(function () {
            var location = window.location.pathname + "?" + _this.serializedState;
            window.history.pushState(null, '', location);
        });
    }
    Object.defineProperty(StateQueryStore.prototype, "serializedState", {
        get: function () {
            var stateEntries = mobx_1.entries(this.state).map(function (_a) {
                var _b = __read(_a, 2), k = _b[0], v = _b[1];
                return [k, v.join('|')];
            });
            return new URLSearchParams(stateEntries).toString();
        },
        enumerable: false,
        configurable: true
    });
    StateQueryStore.prototype.setState = function (key, value) {
        if (value === '' || value.length === 0) {
            mobx_1.remove(this.state, key);
        }
        else {
            var newValue = typeof value === 'string' ? [value] : value;
            newValue = newValue.map(encodeURIComponent);
            this.state[key] = newValue;
        }
    };
    StateQueryStore.prototype.deleteKey = function (key) {
        mobx_1.remove(this.state, key);
    };
    __decorate([
        mobx_1.observable
    ], StateQueryStore.prototype, "state", void 0);
    __decorate([
        mobx_1.computed
    ], StateQueryStore.prototype, "serializedState", null);
    __decorate([
        mobx_1.action
    ], StateQueryStore.prototype, "setState", null);
    __decorate([
        mobx_1.action
    ], StateQueryStore.prototype, "deleteKey", null);
    return StateQueryStore;
}());
exports.StateQueryStore = StateQueryStore;
